import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

const Index: React.FC = () => {
    return (
        <Box component="footer" py={4} bgcolor="grey.100">
            <Container maxWidth="lg" sx={{ textAlign: "center" }}>
                <Typography variant="body2" color="textSecondary">
                    &copy; {new Date().getFullYear()} SoundMonitor.io
                </Typography>
            </Container>
        </Box>
    );
};

export default Index;
